import axios from 'axios'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { ConfigurationTextTemplateResponse } from '@/modules/configurationModule/detail/templates/text-templates/services/text-templates.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class TextTemplatesConfigurationServices {
    async paginator(filterModel: any, params: any, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationTextTemplateResponse>> {
        const response = await axios.put(`/configuration/laboratories/${laboratoryId}/textTemplates`, filterModel, { params })
        return response.data
    }
    async patchTextTemplatesBatch(request: ConfigurationTextTemplateResponse[], laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch(`/configuration/laboratories/${laboratoryId}/textTemplates/batch`, request)
        return response.data
    }
    async createTextTemplates(request: ConfigurationTextTemplateResponse, laboratoryId: number): Promise<ConfigurationTextTemplateResponse> {
        const response = await axios.post(`/configuration/laboratories/${laboratoryId}/textTemplates`, request)
        return response.data
    }
    async deleteTextTemplatesBatch(request: EntityIdentifiersRequest, laboratoryId: number): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete(`/configuration/laboratories/${laboratoryId}/textTemplates/batch`, { data: request })
        return response.data
    }
    async getTextTemplate(laboratoryId: number, textTemplateId: number): Promise<ConfigurationTextTemplateResponse> {
        const response = await axios.get(`/configuration/laboratories/${laboratoryId}/textTemplates/${textTemplateId}`)
        return response.data
    }
}
export const textTemplatesConfigurationServices = new TextTemplatesConfigurationServices()
